import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"

import { StrMakeRequestModal, Button } from "components"
import { moment, haveAuth } from "utils"
import { stockTransferStatusLabels } from "constant"
import StrtrCancelButton from "./StrtrCancelButton"
import StrRequestDetailsModal from "./StrRequestDetailsModal"
import StrRespondToRequestModal from "./StrRespondToRequestModal"
import StrReceivedRequestModal from "./StrReceivedRequestModal"
import StrDeliverRequestModal from "./StrDeliverRequestModal"
import StrResolveDiscrepancyModal from "./StrResolveDiscrepancyModal"
import classes from "./index.module.scss"

const stockTransferStatusColors = {
  pending: "var(--color-warning)",
  approved: "var(--color-info)",
  rejected: "var(--color-danger)",
  incomplete: "var(--color-tertiary)",
  completed: "var(--color-success)",
  inTransit: "var(--color-danger)",
  canceled: "var(--color-secondary)"
}

const StrTableRow = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests
  } = props

  const cashierBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [openMakeRequestModal, setOpenMakeRequestModal] = useState(false)
  const [openRequestDetailsModal, setOpenRequestDetailsModal] = useState(false)
  const [openDeliverConfirmationModal, setOpenDeliverConfirmationModal] = useState(false)
  const [showStockTransferRespondeModal, setShowStockTransferRespondeModal] = useState(false)
  const [showStockTransferReceiveModal, setShowStockTransferReceiveModal] = useState(false)
  const [showStockTransferResolveModal, setShowStockTransferResolveModal] = useState(false)

  const showEditButton =
    haveAuth(["createStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "pending" &&
    stockTransferRequest.destinationBranchId === cashierBranchId

  const showEditApproveButton =
    haveAuth(["respondStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "approved" &&
    stockTransferRequest.sourceBranchId === cashierBranchId

  const showDetailsButton =
    stockTransferRequest.stockTransferStatus !== "pending"

  const showResponseButton =
    haveAuth(["respondStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "pending" &&
    stockTransferRequest.sourceBranchId === cashierBranchId

  const showResolveButton =
    haveAuth(["resolveStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "incomplete" &&
    stockTransferRequest.sourceBranchId === cashierBranchId

  const showTransitButton =
    haveAuth(["deliverStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "approved" &&
    stockTransferRequest.sourceBranchId === cashierBranchId

  const showReceiveButton =
    haveAuth(["receiveStockTransfer"]) &&
    stockTransferRequest.stockTransferStatus === "inTransit" &&
    stockTransferRequest.destinationBranchId === cashierBranchId

  return (
    <Fragment>
      <tr className={classes["container"]}>
        <td>
          {stockTransferRequest.code}
          {
            !stockTransferRequest.isViewed &&
            cashierBranchId === stockTransferRequest.sourceBranchId &&
            <span className={classes["new"]}>
              جدید
            </span>
          }
        </td>
        <td>
          {moment(stockTransferRequest.createdAt).format("jYYYY/jMM/jDD")}
          <br />
          {moment(stockTransferRequest.createdAt).format("HH:mm")}
        </td>
        <td>
          {stockTransferRequest.destinationBranch.name}
        </td>
        <td>
          {stockTransferRequest.sourceBranch.name}
        </td>
        <td>
          <span
            className={classes["tag"]}
            style={{
              backgroundColor: stockTransferStatusColors[stockTransferRequest.stockTransferStatus]
            }}
          >
            {stockTransferStatusLabels[stockTransferRequest.stockTransferStatus]}
          </span>
        </td>
        <td>
          {
            !!stockTransferRequest.startDeliveryDate &&
            <span>
              {moment(stockTransferRequest.startDeliveryDate).format("jYYYY/jMM/jDD")}
              <br />
              {moment(stockTransferRequest.startDeliveryDate).format("HH:mm")}
            </span>
          }
        </td>
        <td>
          {
            !!stockTransferRequest.receivedDate &&
            <span>
              {moment(stockTransferRequest.receivedDate).format("jYYYY/jMM/jDD")}
              <br />
              {moment(stockTransferRequest.receivedDate).format("HH:mm")}
            </span>
          }
        </td>
        <td>
          {
            showDetailsButton &&
            <Button
              className={classes["button-1"]}
              onClick={() => setOpenRequestDetailsModal(true)}
            >
              مشاهده
            </Button>
          }
          {
            showEditButton &&
            <Button
              className={classes["button-1"]}
              onClick={() => setOpenMakeRequestModal(true)}
              color="secondary"
            >
              ویرایش
            </Button>
          }
          {
            showEditApproveButton &&
            <Button
              className={classes["button"]}
              onClick={() => setShowStockTransferRespondeModal(true)}
              color="secondary"
            >
              ویرایش پاسخ
            </Button>
          }
          {
            showTransitButton &&
            <Button
              className={classes["button"]}
              onClick={() => setOpenDeliverConfirmationModal(true)}
              color="warning"
            >
              ارسال محموله
            </Button>
          }
          {
            showEditButton &&
            <StrtrCancelButton
              stockTransferRequest={stockTransferRequest}
              setStockTransferRequests={setStockTransferRequests}
            />
          }
          {
            showResponseButton &&
            <Button
              onClick={() => setShowStockTransferRespondeModal(true)}
              className={classes["button"]}
              color="info"
            >
              پاسخ
            </Button>
          }
          {
            showReceiveButton &&
            <Button
              onClick={() => setShowStockTransferReceiveModal(true)}
              className={classes["button"]}
              color="success"
            >
              دریافت
            </Button>
          }
          {
            showResolveButton &&
            <Button
              onClick={() => setShowStockTransferResolveModal(true)}
              className={classes["button"]}
              color="danger"
            >
              حل مناقصه
            </Button>
          }
        </td>
      </tr>
      <StrMakeRequestModal
        openMakeRequestModal={openMakeRequestModal}
        setOpenMakeRequestModal={setOpenMakeRequestModal}
        stockTransferRequestForEdit={stockTransferRequest}
        setStockTransferRequests={setStockTransferRequests}
      />
      <StrRequestDetailsModal
        stockTransferRequest={stockTransferRequest}
        openRequestDetailsModal={openRequestDetailsModal}
        setOpenRequestDetailsModal={setOpenRequestDetailsModal}
      />
      <StrDeliverRequestModal
        stockTransferRequest={stockTransferRequest}
        setStockTransferRequests={setStockTransferRequests}
        openDeliverConfirmationModal={openDeliverConfirmationModal}
        setOpenDeliverConfirmationModal={setOpenDeliverConfirmationModal}
      />
      <StrReceivedRequestModal
        stockTransferRequest={stockTransferRequest}
        setStockTransferRequests={setStockTransferRequests}
        showStockTransferReceiveModal={showStockTransferReceiveModal}
        setShowStockTransferReceiveModal={setShowStockTransferReceiveModal}
      />
      <StrRespondToRequestModal
        stockTransferRequest={stockTransferRequest}
        setStockTransferRequests={setStockTransferRequests}
        showStockTransferRespondeModal={showStockTransferRespondeModal}
        setShowStockTransferRespondeModal={setShowStockTransferRespondeModal}
      />
      <StrResolveDiscrepancyModal
        stockTransferRequest={stockTransferRequest}
        setStockTransferRequests={setStockTransferRequests}
        showStockTransferResolveModal={showStockTransferResolveModal}
        setShowStockTransferResolveModal={setShowStockTransferResolveModal}
      />
    </Fragment>
  )
}

export default React.memo(StrTableRow)